import { CSSProperties } from 'react';

import { styled, Theme } from '@mui/material';

import CourseUserCell, { courseUserCellClasses } from '../../../../../../../../components/CourseUserCell';
import Tag, { Props as TagProps } from '../../../../../../../../components/Tag/index';
import UserCell from '../../../../../../../../components/UserCell';

export const commentCreatorClasses = {
  ...courseUserCellClasses,
};

const userCellStyles = (theme: Theme): CSSProperties => ({
  maxWidth: '100%', // hack for title to respect parent's width to show ellipses
  padding: 0,
  overflow: 'hidden',
  [`& .${commentCreatorClasses.avatar}`]: {
    width: 40,
    height: 40,
  },
  [`& .${commentCreatorClasses.content}`]: {
    overflow: 'hidden',
  },
  [`& .${commentCreatorClasses.subtitle}`]: {
    fontWeight: theme.typography.fontWeightRegular,
  },
});

export const StyledUserCell = styled(UserCell)(({ theme }) => ({
  ...userCellStyles(theme),
}));

export const StyledCourseUserCell = styled(CourseUserCell)(({ theme }) => ({
  ...userCellStyles(theme),
}));

export const Role = styled((props: DistributiveOmit<TagProps, 'color'>) => (
  <Tag variant="outlined" {...props} color="success" />
))(({ theme }) => ({
  alignSelf: 'flex-start',
}));
